module.exports = __webpack_public_path__ + "img/bg-courtship-phone.38ffebb.png";